import { Button, Text, Box, Input } from "@chakra-ui/react";
import WithAuth from "../components/hoc/with-auth";
import { AuthLayout } from "../components/layouts/index";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index";
import CreditFacilityPage from "../components/pages/credit-facility-page";

// .tsx
const CreditFacilityReport = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Credit Facility Report"
          pageDesc="List of all credits"
        >
          <CreditFacilityPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default CreditFacilityReport;
